const cookieManager = {
  setCookie(cname, cvalue, expire) {
    const date = new Date()
    date.setTime(date.getTime() + expire * 1000)
    const expires = 'expires=' + date.toUTCString()
    document.cookie = cname + '=' + cvalue + '; ' + expires
  },
  getCookie(cname) {
    const name = cname + '='
    const ca = document.cookie.split(';')
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === '') {
        c = c.substring(1)
      }
      if (c.indexOf(name) !== -1) {
        return c.substring(name.length + 1, c.length)
      }
    }
    return ''
  },
};

export default cookieManager
